import { http, results } from './client';

/* All return the signed-in user (including `token`) unless noted. */

export const login = ({ email, password }) =>
  http.post('api/v1/auth/login', { email, password }).then(results);

export const register = ({ email, password, firstname, lastname, phone }) =>
  http.post('api/v1/auth/register', { email, password, firstname, lastname, phone }).then(results);

/** `credential` is the Google ID token from Google Identity Services. */
export const loginWithGoogle = (credential) =>
  http.post('api/v1/auth/google', { code: credential }).then(results);

export const loginWithFacebook = (accessToken) =>
  http.post('api/v1/auth/facebook', { code: accessToken }).then(results);

/** Always succeeds (the backend doesn't reveal whether the email exists). */
export const requestPasswordReset = (email) =>
  http.post('api/v1/auth/forgot-password', { email }).then(results);

/** Completes the emailed reset link. */
export const resetPassword = ({ token, password }) =>
  http.post('api/v1/auth/forgot-password/confirm', { token, password }).then(results);

/** Signed-in password change. */
export const changePassword = ({ oldPassword, newPassword }) =>
  http.post('api/v1/auth/reset-password', { oldPassword, newPassword }).then(results);

export const confirmEmail = (token) =>
  http.post('api/v1/auth/confirm-email', { token }).then(results);

export const deleteAccount = () => http.post('api/v1/auth/delete-account').then(results);

/** Host sign-up from an admin-issued invite link. */
export const registerHost = ({ token, email, password, firstname, lastname, phone }) =>
  http
    .post('api/v1/auth/register-host', { token, email, password, firstname, lastname, phone })
    .then(results);
